var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"page-breadcrumb d-flex justify-content-between"},[_c('h2',{staticClass:"page-title"},[_c('i',{staticClass:"fas fa-tasks"}),_vm._v(" Dashboard Slabs")])])])])
}]

export { render, staticRenderFns }